<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-loading-container [observables]="[feeLevels$, feeHistory$, contracts$, chargeNumbers$]"></ef-loading-container>
    <ef-fee-level-presenter
        [feeLevels]="feeLevels$ | async"
        [feeOnGA]="feeOnGA$ | async"
        [feeHistory]="feeHistory$ | async"
        [contracts]="contracts$ | async"
        [contractTypes]="contractTypes$ | async"
        [chargeNumbers]="chargeNumbers$ | async"
        [process]="process$ | async"
        [userInfo]="userInfo$ | async"
        (SaveFeeLevels)="onSaveFeeLevels($event)"
        (DeleteFeeLevel)="onDeleteFeeLevel($event)"
        (LoadFeeLevels)="onLoadFeeLevels($event)"
        (LoadActiveInactiveFeeLevel)="onLoadActiveInactiveFeeLevel($event)"
        (SaveFeeHistory)="onSaveFeeHistory($event)"
        (LoadFeeHistory)="onLoadFeeHistory($event)"
        (LoadContracts)="onLoadContracts($event)"
        (LoadChargeNumbers)="onLoadChargeNumbers($event)"
        [selectedError]="selectedErrorWithStatus$ | async"
        (ShowError)="this.ShowError.next($event)"
    >
    </ef-fee-level-presenter>
